<template>
    <page-body>

        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
            <el-row :gutter="20" style="margin-right: 10px;">
                    <!-- <el-col :span="12">
                    <el-form-item label="交付时间" required prop="shippedDate" :disabled='disable'>
                      <el-date-picker
                        v-model="shippedDate"
                        align="right"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions" style="width: 75%;" >
                      </el-date-picker>
                    </el-form-item>
                  </el-col> -->
                <el-col :span="12">
                    <el-button type="primary" icon="edit" @click="addItem" :disabled='disable'>新增商品</el-button>
                 </el-col>
                </el-row>
                <br>
                 <el-row :gutter="20">
                    <el-col :span="24">
                        <el-table :data="addForm.items" border tooltip-effect="dark" style="width: 100%">
                            <el-table-column type="index" label="#" width="60">
                            </el-table-column>
                            <el-table-column  label="商品名称"  width="250" >
                                <template scope="scope">
                                  <el-select v-model="scope.row.item" clearable remote placeholder="请输入关键词" filterable style="width: 90%;" @change="selectItem(scope.row)" :remote-method="getItems" >
                                    <el-option v-for="item in items" :key="item.value" :label="item.label" :value="item.value" >
                                    </el-option>
                                  </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="供应商" width="250">
                              <template scope="scope">
                                  <el-select v-model="scope.row.venderName" clearable remote placeholder="请输入关键词" filterable style="width: 90%;" :remote-method="getVenders">
                                    <el-option v-for="item in venders" :key="item.value" :label="item.label" :value="item.value" >
                                    </el-option>
                                  </el-select>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column prop="itemName" label="商品名称" >
                            </el-table-column> -->
                            <el-table-column prop="unit" label="单位" width="75">
                            </el-table-column>
                            <el-table-column prop="spec" label="规格" width="120">
                            </el-table-column>
                            <el-table-column prop="unitQty" label="单位数量" width="120">
                            </el-table-column>
                            <el-table-column prop="manufacture" label="生产厂家" >
                            </el-table-column>
                            <el-table-column  fixed="right" label=""  :disabled='disable' width="120">
                                <template scope="scope">
                                    <el-button type="danger" size="small" icon="delete" @click="removeItem(scope.row)" :disabled='disable'></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            <!-- </div> -->
        </el-form>
        <!-- </div> -->
        <hr style="margin: 1.5rem 0;" />
        <div class="pull-right">
                <el-button type="primary" class="fa fa-save btn btn-info" @click.native="addSubmit" :loading="addLoading" v-if='!disable'>提交</el-button>
                <el-button class="el-icon-arrow-left" @click="back" >返回</el-button>
            </div>
    </page-body>
</template>

<script>
    import { webapi, HTTP} from '../../api/api';
    import util from '../../common/js/util';

    export default {
        data() {
            return {
                pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }]
        },
                disable:false,
                pageSize:15,
                total: 0,
                page: 1,
                listLoading: false,
                sels: [],
                orderNo:'',
                editable:false,
                addFormVisible: false,
                addLoading: false,
                addFormRules: {

                },
                addForm: {
                    items:[],
                    user:''
                },
                items:[],
                venders:[],
                shippedDate:new Date(),
                timeout:  null
            }
        },
        methods: {
             addItem() {
                this.addForm.items.push({
                  item:'',
                    itemName:'',
                    venderName:'',
                    spec:'',
                    unit:'',
                    unitQty:'',
                    manufacture:''
                });
              },
              selectItem(item){
                var object=this.items;
                for (var i = 0; i < object.length; i++) {
                  if (object[i].key == item.item) {
                    item.itemName = object[i].itemName
                    item.unit = object[i].unit
                    item.spec = object[i].spec
                    item.manufacture = object[i].manufacture
                    item.unitQty = object[i].unitQty
                  }
                }

                },
              removeItem(item) {
                var index = this.addForm.items.indexOf(item)
                if (index !== -1) {
                  this.addForm.items.splice(index, 1)
                }
              },

            getItems(query) {
                var vm = this;
                let para = {
                  query:query
                };
                vm.listLoading = true;

                webapi.post('/item/findAll', para)
                  .then(function(response) {
                    if(null!=response.data){
                       vm.items = response.data.map(item => {
                      return {
                        key: item.id,
                        value: item.id,
                        label: item.itemNo+' '+item.itemName+' '+item.spec,
                        itemName:item.itemName,
                        spec:item.spec,
                        unit:item.unit,
                        unitQty:item.unitQty,
                        manufacture:item.manufacture
                      };
                      });
                    }

                    vm.listLoading = false;
                 }).catch((error) => {
                    vm.listLoading = false;
                    vm.$message.error(error.response.data['message']);
                });
            },
            getVenders(query) {
                var vm = this;
                let para = {
                  query:query
                };
                vm.listLoading = true;

                webapi.post('/vender/findAll', para)
                  .then(function(response) {
                    vm.venders = response.data.map(item => {
                return {
                  key: item.id,
                  value: item.id,
                  label: item.venderName
                };
                });
                 }).catch((error) => {
                    vm.$message.error(error.response.data['message']);
                });
            },

            back(){
                this.$router.user = ''
                this.$router.push('/manage/user')
            },

            //新增
            addSubmit: function () {
                let para = Object.assign({}, this.addForm);
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                            this.addLoading = true;
                            webapi.post('/item/createUserItem',para).then((res) => {
                                this.addLoading = false;
                                this.$message({
                                    message: '提交成功',
                                    type: 'success'
                                });
                                this.back()
                            }).catch((error) => {
                                this.addLoading = false;
                                this.$message.error('服务器连接失败,请联系管理员!');
                            });
                    }
                });
                }
              },
        mounted() {
            this.$nextTick(function() {
                var vm = this
                vm.getItems('')
                vm.getVenders()
                if(vm.$router.user&&vm.$router.user!=''){
                    vm.addForm.user = vm.$router.user.id
                    vm.$router.user.items.forEach(function(item){
                        vm.addForm.items.push({
                            item:item.item.id,
                            itemName:item.item.itemName,
                            unit:item.item.unit,
                            spec:item.item.spec,
                            unitQty:item.item.unitQty,
                            manufacture:item.item.manufacture,
                            venderName:item.vender.id
                        });
                    })
                }
            })
        }
      }

</script>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// AddItem.vue?3721796c